// import { AxiosError } from 'axios';
import { toast } from 'react-toastify';
import { omit, uniqueId } from 'lodash';

import api from '../../api';
import fileApi from './fileApi';
import { Arquive } from './types';

export async function getFilesByFolderIdRequest(folderId: string) {
  try {
    const response = await api().get(`/files/folder/${folderId}`);

    return response;
  } catch (error) {
    // const errorStatus = error as AxiosError;
    // switch (errorStatus.response?.status) {
    //   case 401:
    //     setTokensLocalStorage(null);
    //     return null;
    //   default:
    //     return null;
    // }
    console.error(error);
    return null;
  }
}

export async function getFileByIdRequest(
  fileId: string,
  companyId: string,
  userId: string,
) {
  try {
    const response = await api().post(
      `/files/file-id/${fileId}`,
      {},
      {
        headers: {
          companyId,
          userId,
        },
      },
    );

    return response;
  } catch (error) {
    // const errorStatus = error as AxiosError;
    // switch (errorStatus.response?.status) {
    //   case 401:
    //     setTokensLocalStorage(null);
    //     return null;
    //   default:
    //     return null;
    // }
    console.error(error);
    return null;
  }
}

export async function createFileRequest(
  file: Partial<Arquive>,
  userId: string,
  companyId: string,
  isTheme?: boolean,
) {
  try {
    const formattedFormData = omit(file, ['localFile']);
    const localFile = file.localFile as File;
    const isLink = typeof file.url === 'string';
    let filePath = '';

    if (!isLink) {
      filePath = await fileApi.upload(localFile, {
        filename: file.original_name as string,
        folder: file.folder as string,
        metadata: {
          public: String(file.is_public),
        },
      });
    } else {
      filePath = file.url!;
    }

    console.log({ filePath });

    const data = {
      ...(formattedFormData as Partial<Arquive>),
      url: filePath,
      key: filePath,
    };

    const response = await api().post(
      '/files',
      {
        ...data,
        owner_id: userId,
      },
      {
        headers: {
          companyId,
          userId,
          isTheme: isTheme || false,
        },
      },
    );

    return response;
  } catch (error: any) {
    if (error.response.status === 500) {
      toast.error('Erro desconhecido, contate o suporte', {
        toastId: uniqueId(),
      });
    } else {
      toast.error(error.response.data.message, {
        toastId: uniqueId(),
      });
    }
    console.error(error);
    return null;
  }
}

export async function createZipFileRequest(file: Partial<Arquive>) {
  try {
    const localFile = file.localFile as File;
    let filePath = '';

    filePath = await fileApi.uploadZip(localFile, {
      folder: file.folder as string,
      filename: file.original_name as string,
      metadata: {
        public: String(file.is_public),
      },
    });

    console.log({ filePath });

    return filePath;
  } catch (error: any) {
    if (error.response.status === 500) {
      toast.error('Erro desconhecido, contate o suporte', {
        toastId: uniqueId(),
      });
    } else {
      toast.error(error.response.data.message, {
        toastId: uniqueId(),
      });
    }
    console.error(error);
    return null;
  }
}

export async function createMultipleFilesRequest(
  files: File[],
  userId: string,
  folderName: string,
  folderId: string,
  companyId: string,
) {
  try {
    const formData = new FormData();

    // console.log('files', files);

    files.forEach(file => {
      formData.append(`files`, file);
    });

    const response = await api().post('files/multiple-uploads', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        userId,
        folderName,
        folderId,
        companyId,
      },
    });

    return response;
  } catch (error: any) {
    if (error.response.status === 500) {
      toast.error('Erro desconhecido, contate o suporte', {
        toastId: uniqueId(),
      });
    } else {
      toast.error(error.response.data.message, {
        toastId: uniqueId(),
      });
    }
    console.error(error);
    return null;
  }
}

export async function updateWithoutFileRequest(
  file: Partial<Arquive>,
  fileId: string,
  userId: string,
  companyId: string,
) {
  try {
    const response = await api().patch(`/files/${fileId}`, file, {
      headers: {
        userId,
        companyId,
      },
    });

    toast.success('Arquivo editado com sucesso');
    return response;
  } catch (error: any) {
    if (error.response.status === 500) {
      toast.error('Erro desconhecido, contate o suporte', {
        toastId: uniqueId(),
      });
    } else {
      toast.error(error.response.data.message, {
        toastId: uniqueId(),
      });
    }
    console.error(error);
    return null;
  }
}

export async function createAvatarAndLogoRequest(
  file: Partial<Arquive>,
  userId: string,
  companyId: string,
) {
  try {
    const clientApi = await api();
    const fileInBase64 = String(file.localFile);

    const fileBase64Length = fileInBase64.length + 1000;

    const response = await clientApi.post(
      `/files/app/${userId}`,
      {
        original_name: file.original_name,
        mimetype: file.mimetype,
        size: file.size,
        base64_file: fileInBase64 as string,
      },
      {
        headers: {
          companyId,
          'Content-Length': fileBase64Length,
        },
      },
    );

    return response;
  } catch (error: any) {
    if (error.response.status === 500) {
      toast.error('Erro desconhecido, contate o suporte', {
        toastId: uniqueId(),
      });
    } else {
      toast.error(error.response.data.message, {
        toastId: uniqueId(),
      });
    }
    console.error('createFileAppRequest => ', error);
    return null;
  }
}

export async function removeFileInFolderRequest(
  folderId: string,
  fileId: string,
  userId: string,
  companyId: string,
) {
  try {
    const response = await api().patch(
      `/files/remove/${fileId}`,
      {},
      {
        headers: {
          companyId,
          folderId,
          userId,
        },
      },
    );

    return response;
  } catch (error: any) {
    if (error.response.status === 500) {
      toast.error('Erro desconhecido, contate o suporte', {
        toastId: uniqueId(),
      });
    } else {
      toast.error(error.response.data.message, {
        toastId: uniqueId(),
      });
    }

    console.error(error);
    return null;
  }
}

export async function getFileContentByIdRequest(
  fileId: string,
  userId: string,
  companyId: string,
) {
  try {
    const response = await api().post(
      `/files/content/${fileId}`,
      {},
      {
        headers: {
          userId,
          companyId,
        },
      },
    );

    const responseBlob = await fetch(
      `data:application/octet-binary;base64,${response?.data}`,
    ).then(res => res.blob().then(b => URL.createObjectURL(b)));

    return {
      data: responseBlob,
      status: response?.status,
    };
  } catch (error) {
    console.error('Error getFileContentByIdRequest', error);
    return null;
  }
}

export async function updateWithFileRequest(
  file: Partial<Arquive>,
  fileId: string,
  companyId: string,
  userId: string,
) {
  try {
    const sanitizedEmpresaFormData = omit(file, ['localFile']);
    const localFile = file.localFile as File;

    let { url } = file;

    // caso o arquivo tenha sido alterado, faz o upload do novo
    if (localFile) {
      url = await fileApi.upload(localFile, {
        folder: file.folder as string,
        filename: file.original_name as string,
        metadata: {
          public: String(file.is_public),
        },
      });
    }

    const data = {
      ...sanitizedEmpresaFormData,
      url,
    };

    const response = await api().patch(
      `/files/${fileId}`,
      {
        ...data,
      },
      {
        headers: {
          companyId,
          userId,
        },
      },
    );

    if (!localFile) {
      await fileApi.updateMetadata(
        file.url as string,
        {
          public: String(true),
        },
        companyId,
        userId,
      );
    }

    // caso o arquivo tenha sido alterado, o arquivo antigo é removido
    if (localFile && file.url) {
      await removeFileInFolderRequest(file.url, fileId, userId, companyId);
    }

    toast.success('Arquivo editado com sucesso');
    return response;
  } catch (error: any) {
    if (error.response.status === 500) {
      toast.error('Erro desconhecido, contate o suporte', {
        toastId: uniqueId(),
      });
    } else {
      toast.error(error.response.data.message, {
        toastId: uniqueId(),
      });
    }
    console.error(error);
    return null;
  }
}

export async function removeFileRequest(
  fileId: string,
  fileUrl: string,
  userId: string,
  companyId: string,
) {
  try {
    if (!fileUrl) return null;

    // const response = await fileApi.remove(fileUrl, userId, companyId, fileId);
    const response = await removeFileInFolderRequest(
      fileUrl,
      fileId,
      userId,
      companyId,
    );

    return response;
  } catch (error: any) {
    if (error.response.status === 500) {
      toast.error('Erro desconhecido, contate o suporte', {
        toastId: uniqueId(),
      });
    } else {
      toast.error(error.response.data.message, {
        toastId: uniqueId(),
      });
    }
    console.error(error);
    return null;
  }
}

// export async function createFileWithS3(
//   fileData: Partial<Arquive>,
//   userId: string,
// ): Promise<any> {
//   const formattedFormData = omit(fileData, ['localFile']);
//   const localFile = fileData.localFile as File;

//   const filePath = await fileApi.upload(localFile, {
//     folder: fileData.folder as string,
//     filename: fileData.original_name as string,
//     metadata: {
//       public: String(fileData.is_public),
//     },
//   });

//   const data = {
//     ...(formattedFormData as Partial<Arquive>),
//     url: filePath,
//   };

//   const response = await createFileRequest(data, userId);

//   return response;
// }

// export async function updateFileWithS3(
//   fileData: Partial<Arquive>,
//   fileId: string,
// ): Promise<any> {
//   const sanitizedEmpresaFormData = omit(fileData, ['localFile']);
//   const { localFile } = fileData;

//   let { url } = fileData;

//   // caso o arquivo tenha sido alterado, faz o upload do novo
//   if (localFile) {
//     url = await fileApi.upload(localFile, {
//       folder: fileData.folder as string,
//       filename: fileData.original_name as string,
//       metadata: {
//         public: String(fileData.is_public),
//       },
//     });
//   }

//   const data = {
//     ...sanitizedEmpresaFormData,
//     url,
//   };

//   const response = await updateFileRequest(data, fileId);

//   // caso o arquivo não tenha sido alterado, o metadado vai ser alterado de acordo com os dados da requisição
//   if (!localFile) {
//     await fileApi.updateMetadata(fileData.url as string, {
//       public: String(true),
//     });
//   }

//   // caso o arquivo tenha sido alterado, o arquivo antigo é removido
//   if (localFile && fileData.url) {
//     await fileApi.remove(fileData.url);
//   }

//   return response;
// }

// export async function removeFileWithS3(
//   fileData: Partial<Arquive>,
// ): Promise<void> {
//   await removeFileRequest(fileData.id as string, fileData.url);

//   if (!fileData.url) return;

//   await fileApi.remove(fileData.url);
// }
